// 9fbef606107a605d69c0edbcd8029e5d
/**
 * @module ProductAltImages
 *
 * @author Agu
 */
import React from 'react';
import { PropTypes } from 'prop-types';
import {
  isClient,
  getLocator,
  getVideoUrl,
  routerPush,
  getSiteId,
  isSafariBrowser,
  parseBoolean,
} from '@tcp/core/src/utils';
import { setSessionStorage, urlContainsQuery } from '@tcp/core/src/utils/utils.web';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import { filterBundleImageUrl } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { isShopThisStoreModeOn } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getProductListToPath } from '../utils/productsCommonUtils';
// import cssClassName from '../utils/cssClassName';
import styles, { imageAnchorInheritedStyles } from '../styles/ProductAltImages.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import OutOfStockWaterMark from '../../../../ProductDetail/molecules/OutOfStockWaterMark';
import {
  IMG_DATA_PLP,
  VID_DATA_PLP,
  VID_DATA_PLP_WEBP,
  IMG_DATA_PLP_SECURE,
  VID_DATA_SLP,
} from '../config';
import RecommendationsAbstractor from '../../../../../../../services/abstractors/common/recommendations';
import InfluencerBadgeHandle from '../../../../../../common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';

class ProductAltImages extends React.PureComponent {
  nodes = {};

  static propTypes = {
    /** callback for when the shown image changes. Accepts: image index */
    onImageChange: PropTypes.func,
    googleAnalyticsData: PropTypes.func,
    imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
    productName: PropTypes.string.isRequired,
    pdpUrl: PropTypes.string.isRequired,
    analyticsData: PropTypes.shape({
      pId: PropTypes.string.isRequired,
      prank: PropTypes.string.isRequired,
      requestId: PropTypes.string.isRequired,
    }),
    loadedProductCount: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    keepAlive: PropTypes.bool.isRequired,
    isSoldOut: PropTypes.bool,
    soldOutLabel: PropTypes.string,
    isSearchPage: PropTypes.string,
    viaModule: PropTypes.string,
    dataSource: PropTypes.string,
    isProductBrandOfSameDomain: PropTypes.bool,
    itemBrand: PropTypes.string.isRequired,
    page: PropTypes.string,
    cookieToken: PropTypes.string,
    isBundleProduct: PropTypes.bool,
    lowQualityEnabled: PropTypes.bool,
    portalValue: PropTypes.string,
    dynamicBadgeOverlayQty: PropTypes.number,
    tcpStyleType: PropTypes.string,
    recToken: PropTypes.string,
    imageURL: PropTypes.string,
    fromFavorites: PropTypes.bool,
    inGridPlpRecommendation: PropTypes.bool,
    renderTopRatedBadgeItem: PropTypes.func,
    renderBestSellerBadgeItem: PropTypes.func,
    renderMostFavoritedBadgeItem: PropTypes.func,
    isFromPLPPage: PropTypes.bool,
    trackClick: PropTypes.func,
    isTopRatedBadgeEnabledSLP: PropTypes.bool,
    isBestSellerBadgeEnabledSLP: PropTypes.bool,
    isMostFavoritedBadgeEnabled: PropTypes.bool,
    mostFavoritedSLP: PropTypes.bool,
    isMountedTileRedesignAB: PropTypes.bool,
    lazyLoadImage: PropTypes.bool,
    isFavPage: PropTypes.bool,
  };

  static defaultProps = {
    onImageChange: () => {},
    googleAnalyticsData: () => {},
    analyticsData: {},
    isSoldOut: false,
    soldOutLabel: '',
    isSearchPage: 'false',
    viaModule: '',
    dataSource: '',
    isProductBrandOfSameDomain: true,
    page: '',
    cookieToken: null,
    isBundleProduct: false,
    lowQualityEnabled: false,
    portalValue: '',
    dynamicBadgeOverlayQty: 0,
    tcpStyleType: '',
    recToken: '',
    imageURL: '',
    fromFavorites: false,
    inGridPlpRecommendation: false,
    renderTopRatedBadgeItem: () => {},
    renderBestSellerBadgeItem: () => {},
    renderMostFavoritedBadgeItem: () => {},
    isFromPLPPage: false,
    trackClick: () => {},
    isTopRatedBadgeEnabledSLP: false,
    isBestSellerBadgeEnabledSLP: false,
    isMostFavoritedBadgeEnabled: false,
    mostFavoritedSLP: null,
    isMountedTileRedesignAB: false,
    lazyLoadImage: false,
    isFavPage: false,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      currentIndex: 0,
    };

    this.handledPrevImage = this.handledPrevImage.bind(this);
    this.handledNextImage = this.handledNextImage.bind(this);
    this.handlePrevImage = this.handlePrevImage.bind(this);
    this.handleNextImage = this.handleNextImage.bind(this);
  }

  // onVideoError = () => this.setState({ videoError: true });

  productLink = (
    loadedProductCount,
    { to, asPath },
    googleAnalyticsData,
    e,
    isProductBrandOfSameDomain,
    alternateBrand,
    stopRedirection,
    trackClick
  ) => {
    const { isFavoriteView } = this.props;
    const { setCurrentCategoryIdActn, categoryIdToCheck, isFromPLPPage } = this.props;
    if (isFromPLPPage) {
      setCurrentCategoryIdActn(categoryIdToCheck);
    }
    const toPath = alternateBrand ? `${to}$brand=${alternateBrand}` : to;
    const asPathNew = alternateBrand ? `${asPath}$brand=${alternateBrand}` : asPath;
    if (!isProductBrandOfSameDomain && !isFavoriteView) {
      return false;
    }
    e.preventDefault();
    if (stopRedirection) {
      return true;
    }
    if (isClient()) {
      const skuClicked = e?.target
        ?.closest('.item-container-inner')
        ?.getAttribute('unbxdparam_sku');

      setSessionStorage({ key: 'LAST_PAGE_PATH', value: window.location.pathname });
      setSessionStorage({ key: 'LOADED_PRODUCT_COUNT', value: loadedProductCount });
      setSessionStorage({ key: 'SCROLL_POINT', value: window.pageYOffset });
      setSessionStorage({ key: 'UNBXDPARAM_SKU', value: skuClicked });
      setSessionStorage({ key: 'PDP1', value: getLocalStorage('pdp1') });
      setSessionStorage({ key: 'PDP2', value: getLocalStorage('pdp2') });
      routerPush(toPath, asPathNew);
    }
    googleAnalyticsData();
    trackClick();
    return true;
  };

  getPDPAsPath = ({ pdpUrl, cookieToken, isProductBrandOfSameDomain, stsPart }) => {
    let pdpAsPath = pdpUrl;
    const { isFavoriteView } = this.props;
    if (cookieToken && !isProductBrandOfSameDomain) {
      // /us/ was appending twice in case of cross-brand products.
      pdpAsPath =
        isFavoriteView && !isProductBrandOfSameDomain ? pdpAsPath?.replace('/us/', '/') : pdpAsPath;
      pdpAsPath = `${pdpAsPath}${urlContainsQuery(pdpAsPath) ? '&' : '?'}ct=${cookieToken}`;
    }
    if (stsPart) {
      pdpAsPath = `${pdpAsPath}${urlContainsQuery(pdpAsPath) ? '&' : '?'}${stsPart}`;
    }
    return pdpAsPath;
  };

  getVideoTransformation = (forceWebpForVideo) => {
    if (forceWebpForVideo) {
      return VID_DATA_SLP;
    }
    return isSafariBrowser() ? VID_DATA_PLP : VID_DATA_PLP_WEBP;
  };

  getPdpPageUrl = (
    pdpToPath,
    isSearchPage,
    viaModule,
    page,
    dataSource,
    recIdentifier,
    recToken,
    TCPPrimaryCategory,
    stsSlug
  ) => {
    const { isFavoriteView, isProductBrandOfSameDomain } = this.props;
    const pdpToPathNew =
      isFavoriteView && !isProductBrandOfSameDomain ? getProductListToPath(pdpToPath) : pdpToPath;
    return (
      pdpToPathNew &&
      `${pdpToPathNew}&isSearchPage=${isSearchPage}&viaModule=${viaModule}&viaPage=${page}&dataSource=${dataSource}${
        recIdentifier ? `&recommendationCarousel=${recIdentifier}` : ''
      }${recToken ? `&recToken=${recToken}` : ''}${
        TCPPrimaryCategory ? `&tcpPrimaryCategory=${TCPPrimaryCategory}` : ``
      }${stsSlug}`
    );
  };

  getUnboxdData = (analyticsData) => {
    return analyticsData || {};
  };

  getFilteredPdpToPath = (isBundleProduct, pdpToPath, siteId) => {
    return !isBundleProduct
      ? pdpToPath.replace('/p?pid=', `/${siteId}/p/`)
      : pdpToPath.replace('/b?bid=', `/${siteId}/b/`);
  };

  getPdpToPath = (isProductBrandOfSameDomain, pdpUrl) => {
    return isProductBrandOfSameDomain ? getProductListToPath(pdpUrl) : pdpUrl;
  };

  handledNextImage() {
    const { currentIndex } = this.state;
    const { imageUrls, onImageChange } = this.props;
    let idx = currentIndex + 1;
    if (idx > imageUrls.length) {
      idx = 0;
    }
    this.setState({ currentIndex: idx });
    if (onImageChange) onImageChange(idx);
  }

  handledPrevImage() {
    const { currentIndex } = this.state;
    const { imageUrls, onImageChange } = this.props;
    let idx = currentIndex - 1;
    if (idx < 0) {
      idx += imageUrls.length + 1;
    }
    this.setState({ currentIndex: idx });
    if (onImageChange) onImageChange(idx);
  }

  handlePrevImage() {
    const { currentIndex } = this.state;
    const { imageUrls, onImageChange } = this.props;
    let idx = currentIndex - 1;
    if (idx < 0) {
      idx += imageUrls.length;
    }
    this.setState({ currentIndex: idx });
    if (onImageChange) onImageChange(idx);
  }

  handleNextImage() {
    const { currentIndex } = this.state;
    const { imageUrls, onImageChange } = this.props;
    const idx = (currentIndex + 1) % imageUrls.length;
    this.setState({ currentIndex: idx });
    if (onImageChange) onImageChange(idx);
  }

  renderSoldOutSection = () => {
    const { isSoldOut, keepAlive, soldOutLabel, isFavPage } = this.props;
    return isSoldOut || keepAlive ? (
      <OutOfStockWaterMark label={soldOutLabel} isFavPage={isFavPage} />
    ) : null;
  };

  static contextType = LabelsContext;

  renderDamImage(disableVideoClickHandler = false) {
    const {
      imageUrls,
      productName,
      itemBrand,
      lowQualityEnabled,
      dynamicBadgeOverlayQty,
      tcpStyleType,
      fromFavorites,
      imageURL,
      isSecureImageFlagEnabled,
      primaryBrand,
      pdpUrl,
      isHomePage,
      isSLP,
      viaModule,
      lazyLoadImage,
    } = this.props;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled, isDamImageV2EnabledPLP } = extraConfig || {};
    const { currentIndex } = this.state;
    const imgData = {
      alt: productName,
      url: pdpUrl?.includes('/b/')
        ? filterBundleImageUrl(imageUrls[currentIndex])
        : imageUrls[currentIndex],
    };
    const forceWebpForVideo = isSLP || viaModule === 'Recommendation';
    let configData;
    // TODO in case of having bundle product name key on cloudinary
    // const configData = isBundleProduct ? IMG_DATA_CLP : IMG_DATA_PLP;

    const isVideoUrl = getVideoUrl(imgData.url);
    if (isSecureImageFlagEnabled) {
      configData = isVideoUrl
        ? this.getVideoTransformation(forceWebpForVideo)
        : IMG_DATA_PLP_SECURE;
    } else {
      configData = isVideoUrl ? this.getVideoTransformation(forceWebpForVideo) : IMG_DATA_PLP;
    }

    return (
      <>
        <DamImage
          {...this.props}
          className="loadImage"
          dataLocator={getLocator('global_productimg_imagelink')}
          imgData={imgData}
          imgConfigs={configData.imgConfig}
          isProductImage
          noSourcePictureTag
          fromFavorites={fromFavorites}
          imageURL={imageURL}
          itemBrand={itemBrand}
          disableVideoClickHandler={disableVideoClickHandler}
          isOptimizedVideo
          lowQualityEnabled={lowQualityEnabled}
          dynamicBadgeOverlayQty={currentIndex === 0 ? dynamicBadgeOverlayQty : 0}
          tcpStyleType={tcpStyleType}
          badgeConfig={IMG_DATA_PLP.badgeConfig}
          lazyLoad
          isSecureImageFlagEnabled={isSecureImageFlagEnabled}
          primaryBrand={primaryBrand}
          tabIndex="0"
          isHomePage={isHomePage}
          forceWebpForVideo={forceWebpForVideo}
          isDamImageV2Enabled={isDamImageV2Enabled}
          isDamImageV2EnabledPLP={isDamImageV2EnabledPLP}
          lazyLoadImage={lazyLoadImage}
        />
        {this.renderSoldOutSection()}
      </>
    );
  }

  renderTopRatedBestSellerMostFavBadges = () => {
    const {
      inGridPlpRecommendation,
      renderTopRatedBadgeItem,
      renderBestSellerBadgeItem,
      renderMostFavoritedBadgeItem,
      topRatedSLP,
      bestSellerSLP,
      mostFavoritedSLP,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      isMostFavoritedBadgeEnabled,
    } = this.props;
    const isTopRatedSLP = !inGridPlpRecommendation && isTopRatedBadgeEnabledSLP && topRatedSLP;
    const isBestSellerSLP =
      !inGridPlpRecommendation && isBestSellerBadgeEnabledSLP && bestSellerSLP;
    const isMostFavoritedSLP =
      !inGridPlpRecommendation && !isMostFavoritedBadgeEnabled && mostFavoritedSLP;
    const allBadgesTrue = isTopRatedSLP && isBestSellerSLP && isMostFavoritedSLP;
    return (
      <>
        {allBadgesTrue ? (
          <div className="top-badge-container">
            {isBestSellerSLP && renderBestSellerBadgeItem()}
            {isTopRatedSLP && renderTopRatedBadgeItem()}
          </div>
        ) : (
          <div className="top-badge-container">
            {isBestSellerSLP && renderBestSellerBadgeItem()}
            {isTopRatedSLP && renderTopRatedBadgeItem()}
            {isMostFavoritedSLP && renderMostFavoritedBadgeItem()}
          </div>
        )}
      </>
    );
  };

  renderDamWrapper() {
    const {
      pdpUrl,
      productName,
      loadedProductCount,
      isSearchPage,
      isProductBrandOfSameDomain,
      viaModule,
      dataSource,
      page,
      cookieToken,
      isBundleProduct,
      googleAnalyticsData,
      portalValue = '',
      recToken,
      alternateBrand,
      stopRedirection,
      trackClick,
      TCPPrimaryCategory,
    } = this.props;

    const siteId = getSiteId();
    const pdpToPath = this.getPdpToPath(isProductBrandOfSameDomain, pdpUrl);

    const recIdentifier = RecommendationsAbstractor.handleWhichRecommendationClicked(
      portalValue,
      page
    );
    const stsSlug =
      isShopThisStoreModeOn() && parseBoolean(isSearchPage) ? '&mode=shop-this-store' : '';
    const stsPart =
      isShopThisStoreModeOn() && parseBoolean(isSearchPage) ? 'mode=shop-this-store' : '';
    const pdpPageUrl = this.getPdpPageUrl(
      pdpToPath,
      isSearchPage,
      viaModule,
      page,
      dataSource,
      recIdentifier,
      recToken,
      TCPPrimaryCategory,
      stsSlug
    );

    const pdpAsPath = `${this.getPDPAsPath({
      pdpUrl,
      cookieToken,
      isProductBrandOfSameDomain,
      stsPart,
    })}`;
    const filteredPdpToPath = this.getFilteredPdpToPath(isBundleProduct, pdpToPath, siteId);
    const stsPartQuery = `${urlContainsQuery(filteredPdpToPath) ? '&' : '?'}${stsPart}`;
    const toPath = alternateBrand
      ? `${filteredPdpToPath}$brand=${alternateBrand}${stsPart ? stsPartQuery : ''}`
      : `${filteredPdpToPath}${stsPart ? stsPartQuery : ''}`;
    return (
      <Anchor
        handleLinkClick={(e) => {
          e.preventDefault();
          setTimeout(() => {
            this.productLink(
              loadedProductCount,
              { to: pdpPageUrl, asPath: pdpAsPath },
              googleAnalyticsData,
              e,
              isProductBrandOfSameDomain,
              alternateBrand,
              stopRedirection,
              trackClick,
              TCPPrimaryCategory
            );
          }, 0);
        }}
        title={productName}
        inheritedStyles={imageAnchorInheritedStyles}
        to={toPath}
        asPath={pdpAsPath}
        tabIndex="-1"
        noLink
      >
        {this.renderDamImage()}
      </Anchor>
    );
  }

  renderImage() {
    const {
      imageUrls,
      productName,
      className,
      imageURL,
      fromFavorites,
      influencerTags,
      pdpUrl,
      isSLP,
      isInfluencerBadgeEnabled,
      isFavoriteView,
    } = this.props;
    const { currentIndex } = this.state;
    const image = pdpUrl?.includes('/b/')
      ? filterBundleImageUrl(imageUrls[currentIndex])
      : imageUrls[currentIndex];
    return imageUrls.length < 2 || imageURL || fromFavorites ? (
      <figure
        className={`${className} product-image-container`}
        itemScope
        itemType="http://schema.org/ImageObject"
        data-locator="product_image"
      >
        {this.renderDamWrapper()}
        <InfluencerBadgeHandle
          image={image || imageURL}
          index={currentIndex}
          influencerTags={influencerTags}
          isPreviewImage
          isAbOn={isInfluencerBadgeEnabled && (isSLP || isFavoriteView)}
          isFavoriteView={isFavoriteView}
        />
      </figure>
    ) : (
      <figure
        // eslint-disable-next-line no-return-assign
        ref={(node) => (this.nodes[productName] = node)}
        className={`${className} product-image-container`}
        itemScope
        itemType="http://schema.org/ImageObject"
        data-locator="product_image"
      >
        <button
          data-locator={getLocator('global_imagecursors_arrows')}
          type="button"
          className="button-prev hide-on-mobile"
          onClick={this.handlePrevImage}
        >
          prev
        </button>
        {this.renderDamWrapper()}
        <InfluencerBadgeHandle
          image={image || imageURL}
          index={currentIndex}
          influencerTags={influencerTags}
          isPreviewImage
          isAbOn={isInfluencerBadgeEnabled && (isSLP || isFavoriteView)}
          isFavoriteView={isFavoriteView}
        />
        <button
          data-locator={getLocator('global_imagecursors_arrows')}
          type="button"
          className="button-next hide-on-mobile"
          onClick={this.handleNextImage}
        >
          next
        </button>
      </figure>
    );
  }

  renderImageContent() {
    const {
      viaModule,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      isSearchPage,
      topRatedSLP,
      bestSellerSLP,
      mostFavoritedSLP,
      isMountedTileRedesignAB,
    } = this.props;
    const isTopRatedOrBestSellerSLP =
      viaModule !== 'Recommendation' &&
      isSearchPage &&
      !isMountedTileRedesignAB &&
      (isTopRatedBadgeEnabledSLP || isBestSellerBadgeEnabledSLP) &&
      (topRatedSLP || bestSellerSLP || mostFavoritedSLP);
    return isTopRatedOrBestSellerSLP ? (
      <div className="relative">
        {this.renderImage()}
        {this.renderTopRatedBestSellerMostFavBadges()}
      </div>
    ) : (
      this.renderImage()
    );
  }

  // We are rendering only Images content
  render() {
    return this.renderImageContent();
  }
}

export default withStyles(ProductAltImages, styles);

export { ProductAltImages as ProductAltImagesVanilla };
